import { FC } from "react"
import { ActivityTableRow } from "../../../../../types"
import ActivityCard from "../../card"
import { useActivityNavigation } from "../../hooks/useActivityNavigation"

interface Props {
  info: ActivityTableRow
  isBrandActivity?: boolean
}

const DescriptionCell: FC<Props> = ({ info, isBrandActivity }) => {
  const { isNavigating, handleClick } = useActivityNavigation(info)

  return (
    <td className="py-0 px-0" colSpan={3}>
      <ActivityCard
        activity={info}
        member={info.detail?.lo}
        isLoActivity={info.isLoActivity}
        isBrandActivity={isBrandActivity}
        isNavigating={isNavigating}
        onClick={handleClick}
      />
    </td>
  )
}

export default DescriptionCell
